import React from 'react';
import cn from 'classnames';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';

import styles from './styles.styl';

function Shape({
  className,
  renderPrimary,
  renderSecondary,
  renderLeft,
  renderRight,
  onClick,
  active,
  children,
  withoutMargin,
}) {
  function renderBody() {
    if (children) return children;

    return (
      <div styleName="ShapeRow">
        {renderLeft && <div styleName="ShapeLeft">{renderLeft()}</div>}
        <div styleName="ShapeRowDetails">
          <div styleName="ShapeContent">
            <div styleName="ShapeContent-primary">{renderPrimary()}</div>
            {renderSecondary && (
              <p styleName="ShapeContent-secondary">{renderSecondary()}</p>
            )}
          </div>
          <div>
            {renderRight && (
              <p styleName="ShapeContent-right ShapeContent-secondary">
                {renderRight()}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={className}
      styleName={cn('Shape', {
        pointer: !!onClick,
        active,
        'Shape--withoutMargin': withoutMargin,
      })}
      onClick={onClick}
    >
      {renderBody()}
    </div>
  );
}

Shape.propTypes = {
  className: PropTypes.string,
  renderPrimary: PropTypes.func,
  renderSecondary: PropTypes.func,
  renderLeft: PropTypes.func,
  renderRight: PropTypes.func,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  withoutMargin: PropTypes.bool,
};

export default CSSModules(styles, { allowMultiple: true })(Shape);



// WEBPACK FOOTER //
// ./src/components/common/Shape/index.jsx